import React, { useState } from "react";
import classNames from "classnames";
import { UncontrolledTooltip } from "reactstrap";

const INTERACTIVE_ELEMENTS = new Set([
  "a",
  "button",
  "input",
  "select",
  "textarea",
]);

let tooltipSequence = 0;

const extractTooltipText = (content) => {
  if (typeof content === "string" || typeof content === "number")
    return String(content);

  if (Array.isArray(content)) {
    const values = content.map(extractTooltipText);
    if (values.some((value) => value === null)) return null;
    return values.filter(Boolean).join(" ");
  }

  if (!React.isValidElement(content)) return null;
  if (typeof content.type !== "string") return null;
  if (INTERACTIVE_ELEMENTS.has(content.type)) return null;

  return extractTooltipText(content.props.children);
};

export default function DataTableCell({
  children,
  className,
  toggleSort,
  ...cellProps
}) {
  void toggleSort;

  const [tooltipId] = useState(
    () => `dhn-data-table-cell-tooltip-${++tooltipSequence}`,
  );
  const tooltipText = extractTooltipText(children)?.trim();

  return (
    <div
      {...cellProps}
      className={classNames("rt-td", className)}
      role="gridcell"
    >
      {tooltipText ? (
        <>
          <span id={tooltipId} className="dhn-data-table__tooltip-target">
            {children}
          </span>
          <UncontrolledTooltip
            className="dhn-data-table__tooltip"
            placement="top"
            boundariesElement="window"
            target={tooltipId}
          >
            {tooltipText}
          </UncontrolledTooltip>
        </>
      ) : (
        children
      )}
    </div>
  );
}
